import { forwardRef } from 'react'
import { requireAccessibleName, resolveComponentVariant } from '../componentContract'
import styles from './Primitives.module.css'

const variants = ['secondary', 'ghost', 'danger']

export const IconButton = forwardRef(function IconButton({
  label,
  tooltip,
  title,
  variant = 'secondary',
  className = '',
  children,
  type = 'button',
  ...rest
}, ref) {
  const accessibleName = requireAccessibleName('IconButton', label || rest['aria-label'])
  const resolvedVariant = resolveComponentVariant('IconButton variant', variant, variants, 'secondary')
  // An explicit title wins so a wrapping <Tooltip> can suppress the native one.
  const nativeTitle = title !== undefined ? title : (tooltip || accessibleName)

  return (
    <button
      {...rest}
      ref={ref}
      type={type}
      className={[
        styles.iconButton,
        resolvedVariant === 'ghost' ? styles.iconButtonGhost : '',
        resolvedVariant === 'danger' ? styles.iconButtonDanger : '',
        className,
      ].filter(Boolean).join(' ')}
      aria-label={accessibleName}
      title={nativeTitle || undefined}
    >
      {children}
    </button>
  )
})
